module.exports = __webpack_public_path__ + "static/img/wolfman.e22ed1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/wolfman.jpg
// module id = L13V
// module chunks = 0